import { Reducer } from "redux";

import { DebugAction, DebugActionTypes, DebugState } from "./types";

const initialState: DebugState = {
  isLoading: { startSearch: false, results: false },
  errors: {},
};

const reducer: Reducer<DebugState, DebugAction> = (state = initialState, action) => {
  switch (action.type) {
    case DebugActionTypes.START_SEARCH_REQUEST:
      return { ...initialState, errors: {}, isLoading: { ...state.isLoading, startSearch: true } };
    case DebugActionTypes.START_SEARCH_SUCCESS:
      return { ...state, isLoading: { ...state.isLoading, startSearch: false, results: true } };
    case DebugActionTypes.START_SEARCH_ERROR:
      return { ...state, errors: { search: action.payload }, isLoading: { ...state.isLoading, startSearch: false } };

    case DebugActionTypes.FETCH_DEBUG_SEARCH_RESULTS_ERROR:
      return { ...state, isLoading: { ...state.isLoading, results: false } };
    case DebugActionTypes.FETCH_DEBUG_SEARCH_RESULTS_SUCCESS:
      return { ...state, ...action.payload, isLoading: { ...state.isLoading, results: false } };

    case DebugActionTypes.REMOVE_SEARCH_RESULTS:
      return { errors: state.errors, isLoading: state.isLoading };
    default:
      return state;
  }
};

export default reducer;
